import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Formik } from "formik";
import React from "react";

import { PlatformAccount } from "@/interfaces/talk2pay.iterfaces";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

import GeneralInfoField from "./components/generalInfoField";
import BankAccountCard from "./components/generalInfoField/bankAccount";
import PaymentTypeCard from "./components/generalInfoField/paymentType";
import { buildInitialData } from "./form-data";

type Props = {
  messages: T2PayHomeMessages;
  accountInfo: PlatformAccount | null;
  isLoading: boolean;
};

function GeneralInformation({ messages, accountInfo, isLoading }: Props) {
  return (
    <Formik
      initialValues={buildInitialData(accountInfo)}
      validateOnChange={false}
      enableReinitialize
      onSubmit={() => {
        return;
      }}
    >
      {() => (
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 12 }}>
            {isLoading ? (
              <Skeleton variant="rectangular" width="100%" height={150} />
            ) : (
              <GeneralInfoField messages={messages} />
            )}
          </Grid>

          <Grid size={{ xs: 12, lg: 12 }}>
            {isLoading ? (
              <Skeleton variant="rectangular" width="100%" height={150} />
            ) : (
              <BankAccountCard messages={messages} />
            )}
          </Grid>

          <Grid size={{ xs: 12, lg: 12 }}>
            {isLoading ? (
              <Skeleton variant="rectangular" width="100%" height={150} />
            ) : (
              <PaymentTypeCard />
            )}
          </Grid>
        </Grid>
      )}
    </Formik>
  );
}

export default GeneralInformation;
